import { render, staticRenderFns } from "./CashflowSecondaryDetail.vue?vue&type=template&id=2a9cc708&"
import script from "./CashflowSecondaryDetail.vue?vue&type=script&lang=js&"
export * from "./CashflowSecondaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CashflowSecondaryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VNavigationDrawer,VSimpleTable})
